import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCriteriaDetails } from "../../services/criteriaDetails";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useDeleteCriteriaDetails = (indicator: IIndicators) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteCriteriaDetails,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["criteria-groups"] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Criteria details deleted successfully");
            }
        },
        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    });
};

export default useDeleteCriteriaDetails;